import { createSlice } from "@reduxjs/toolkit";
import {
  getEnrollmentLoadList,
  getEnrollmentByIdLoad,
  deleteEnrollmentLoad,
  createEnrollmentLoad,
  updateEnrollmentLoad,
} from "./LoadEnrollment.thunk";

const baseState = {
  enrollmentData: [],
  enrollmentSelected: null,
  enrollmentDataById: null,
  page: 1,
  pageSize: 5,
  totalPages: 0,
  totalRecords: 0,
  status: "idle", // 'idle' | 'loading' | 'succeeded' | 'failed'
  statusRetrieve: "idle", // 'idle' | 'loading' | 'succeeded' | 'failed'
  statusCreate: "idle", // 'idle' | 'loading' | 'succeeded' | 'failed'
  statusUpdate: "idle", // 'idle' | 'loading' | 'succeeded' | 'failed'
  error: null,
};

const initialState = {
  ...baseState,
};

export const loadEnrollmentSlice = createSlice({
  name: "loadEnrollment",
  initialState,
  reducers: {
    SetEnrollmentSelected: (state, action) => {
      const { enrollmentSelected } = action.payload;
      state.enrollmentSelected = enrollmentSelected;
    },
    ResetDataFilteredByid: (state) => {
      state.enrollmentDataById = null;
      state.statusRetrieve = "idle";
    },
    ResetStore: (state) => {
      state = { ...baseState };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getEnrollmentLoadList.pending, (state) => {
        state.status = "loading";
        state.enrollmentData = [];
        state.page = 1;
        state.pageSize = 5;
        state.totalPages = 0;
        state.totalRecords = 0;
      })
      .addCase(getEnrollmentLoadList.fulfilled, (state, action) => {
        const { enrollmentData, page, page_size, total_pages, total_records } =
          action.payload;
        state.status = "succeeded";
        state.enrollmentData = enrollmentData;
        state.page = page;
        state.pageSize = page_size;
        state.totalPages = total_pages;
        state.totalRecords = total_records;
      })
      .addCase(getEnrollmentLoadList.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload.message;
      });
    builder
      .addCase(deleteEnrollmentLoad.pending, (state) => {
        state.status = "loading";
      })
      .addCase(deleteEnrollmentLoad.fulfilled, (state) => {
        state.status = "succeeded";
      })
      .addCase(deleteEnrollmentLoad.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload.message;
      });
    builder
      .addCase(getEnrollmentByIdLoad.pending, (state) => {
        state.statusRetrieve = "loading";
      })
      .addCase(getEnrollmentByIdLoad.fulfilled, (state, action) => {
        const { enrollmentFilterdById } = action.payload;
        state.statusRetrieve = "succeeded";
        state.enrollmentDataById = enrollmentFilterdById;
      })
      .addCase(getEnrollmentByIdLoad.rejected, (state, action) => {
        state.statusRetrieve = "failed";
        state.error = action.payload.message;
      });
    builder
      .addCase(createEnrollmentLoad.pending, (state) => {
        state.statusCreate = "loading";
      })
      .addCase(createEnrollmentLoad.fulfilled, (state, action) => {
        const { enrollmentCreated } = action.payload;
        state.statusCreate = "succeeded";
        state.enrollmentDataById = enrollmentCreated;
      })
      .addCase(createEnrollmentLoad.rejected, (state, action) => {
        state.statusCreate = "failed";
        state.error = action.payload.message;
      });
    builder
      .addCase(updateEnrollmentLoad.pending, (state) => {
        state.statusUpdate = "loading";
      })
      .addCase(updateEnrollmentLoad.fulfilled, (state, action) => {
        const { enrollmentUpdated } = action.payload;
        state.statusUpdate = "succeeded";
        state.enrollmentDataById = enrollmentUpdated;
      })
      .addCase(updateEnrollmentLoad.rejected, (state, action) => {
        state.statusUpdate = "failed";
        state.error = action.payload.message;
      });
  },
});

export const { ResetStore, SetEnrollmentSelected, ResetDataFilteredByid } =
  loadEnrollmentSlice.actions;

export default loadEnrollmentSlice.reducer;
